<template>
  <v-container fluid>
    <v-card class="pl-10 pr-10 pt-10 pb-10">
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>New Patent Docket</h3>
          </v-col>
          <v-col cols="6" md="6"></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="heightsize90formadvance">
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Object Type</h3>
            <v-autocomplete
              v-model="itemdata.objecttype"
              :items="objecttype_list"
              item-text="objecttype_code"
              item-value="objecttype_id"
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" >
            <h3><span class="red--text">* </span>PF Work Type</h3>
            <v-autocomplete
              v-model="itemdata.doctype"
              :items="documenttype_ptlist"
              item-text="documenttype_code"
              item-value="documenttype_id"
              outlined
              dense
              @input="calDateFinalDeadline()"
            ></v-autocomplete
          ></v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Client Name</h3>
            <v-text-field
              v-model="itemdata.trademark_name"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row  class="heightsize90formadvance">
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>File No.</h3>
            <v-text-field
              class="widthsizesearch heightsizesearch"
              outlined
              dense
              v-on:keyup.enter="onSearchfile_no(itemdata.refno)"
              @blur="onSearchfile_no(itemdata.refno)"
              v-model="itemdata.refno"
            ></v-text-field>
            <h4 class="red--text">
              * input text and enter for search
            </h4>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Application No.</h3>
            <v-text-field
              v-model="app_noshow"
              disabled
              background-color="#F5F5F5"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Category</h3>
            <v-autocomplete
              v-model="itemdata.categories"
              :items="category_ptlist"
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          
        </v-row>
        <v-row class="mt-10" align="start">
          <v-col cols="4" sm="4" md="3">
            <h3>Upload Notice File</h3>
            <input
              type="file"
              accept="application/pdf,image/png,image/jpeg"
              multiple="multiple"
              @change="previewMultiFile"
              ref="noticefile"
              style="display: none"
            />
            <v-btn
              :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }"
              @click="$refs.noticefile.click()"
              class="widthbtnnoticefile"
              elevation="7"
            >
              <v-icon left dark color="white"> mdi-cloud-upload </v-icon
              >Upload</v-btn
            >
          </v-col>
          <v-col cols="1" sm="1" md="1" />
          <v-col cols="7" sm="7" md="8" class="mt-10">
            <div v-if="this.filenamenotice.length > 0">
              <v-row
                v-for="(item, index) in filenamenotice"
                :key="index"
              >
                <span 
                  @click="previewnoticefilepdf(index)"
                  class="file-link"
                >
                  {{ item}}
                </span>  
                <v-btn
                  icon
                  color="red"
                  @click="confirmdeletenoticefile(index)"
                  style="margin-top: -7px;"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                  
                </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row  class="mb-5" align="start">
          <v-col cols="4" sm="4" md="3">
            <h3>Upload Files</h3>
            <input
              type="file"
              accept="application/pdf,image/png,image/jpeg"
              multiple="multiple"
              @change="previewMultiAttachFile"
              ref="attachfile"
              style="display: none"
            />
            <v-btn
              :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }"
              @click="$refs.attachfile.click()"
              class="widthbtnnoticefile"
              elevation="7"
            >
              <v-icon left dark color="white"> mdi-cloud-upload </v-icon
              >Upload</v-btn
            >
          </v-col>
          <v-col cols="1" sm="1" md="1" />
          <v-col cols="7" sm="7" md="8" class="mt-10">
            <div v-if="this.image_listattach.length > 0">
                <v-row
                  v-for="(item, index) in this.image_listattach"
                  :key="index"
                >
                    <span 
                      @click="previewattachfile(index)"
                      class="file-link"
                    >
                      {{ item.name }}
                    </span>  
                    <v-btn
                      icon
                      color="red"
                      @click="confirmdeleteattachfile(index)"
                      style="margin-top: -7px;"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
              <!-- <span v-for="(item, index) in this.getpreview_listattach" :key="index">
              <v-row v-if="image_listattach[index].name.split('.').pop() == 'pdf' || image_listattach[index].name.split('.').pop() == 'PDF'">
                  <v-col
                    class="d-flex child-flex"
                  >
                    <v-card-text>
                      <v-img
                        @click="previewattachfile(index)"
                        disabled
                        class="grey lighten-2 mt-3 mb-5"
                        aspect-ratio="1"
                        contain
                      >
                        <pdf
                          :src="item"
                          :page="1"
                          :scale.sync="scale"
                          style="width:100%;margin:20px auto;"
                          :annotation="true"
                          :resize="true"
                          @link-clicked="handle_pdf_link"
                        >
                          <template slot="loading">
                            loading content here...
                          </template>
                        </pdf>
                      </v-img>
                      <v-btn
                        depressed
                        width="100%"
                        class="buttonred mt-n7"
                        @click="confirmdeleteattachfile(index)"
                      >
                        Delete 
                      </v-btn>
                    </v-card-text>
                  </v-col>
                </v-row>

               <v-row v-else>
              <v-col  class="d-flex child-flex" cols="12">
                  <v-img
                    @click="previewattachfile(index)"
                    disabled
                    :src="item"
                    class="grey lighten-2 mt-3 mb-5"
                    aspect-ratio="1"
                    contain
                  >
                  </v-img>
                </v-col>
                <v-col class="d-flex child-flex" cols="12">
                  <v-btn
                    depressed
                    width="100%"
                    class="buttonred mt-n7"
                    @click="confirmdeleteattachfile(index)"
                  >
                    Delete 
                  </v-btn>
                </v-col>
              </v-row>
              </span> -->
            </div>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance">
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Receive Date</h3>
            <v-menu
              v-model="menuReceive"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.receive_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    receive_date = parseDate(itemdata.receive_date)
                  "
                  @blur="receive_date = parseDate(itemdata.receive_date)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="receive_date"
                @input="() => { menuReceive = false; calDateFinalDeadline(); }"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Final Deadline</h3>
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.enddate"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="enddate = parseDate(itemdata.enddate)"
                  @blur="enddate = parseDate(itemdata.enddate)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="enddate"
                @input="menuStart = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Internal Date</h3>
            <v-menu
              v-model="menuDeadline"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.internaldate"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    internaldate = parseDate(itemdata.internaldate)
                  "
                  @blur="internaldate = parseDate(itemdata.internaldate)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="internaldate"
                @input="menuDeadline = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3"></v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col cols="12" sm="3" md="3">
            <h3>Source Type</h3>
            <v-select
              v-model="itemdata.sourcetype"
              clearable
              :items="sourcetypelist"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Type</h3>
            <v-select
              v-model="typeshow"
              clearable
              :items="typelist"
              item-text="type_name"
              item-value="type_number"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Title</h3>
            <v-text-field
              v-model="titleshow"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col cols="12" sm="6" md="6">
            <h3>Description</h3>
            <v-textarea v-model="itemdata.description" outlined dense>
            </v-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Remark</h3>
            <v-textarea v-model="itemdata.remark" outlined dense> </v-textarea>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12"  md="2">
            <v-row class="mt-3">
              <v-col cols="12" md="4" >
                <v-checkbox
                  v-model="itemdata.report"
                  :label="`Report`"
                  color="success"
                  hide-details
                ></v-checkbox>
                &nbsp;
              </v-col>
              <v-col cols="12"  md="4"></v-col>
              <!-- <v-col cols="12" sm="7" md="7">
                <v-checkbox
                  v-model="itemdata.paymentrequest"
                  :label="`Payment Request`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col> -->
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="itemdata.cert"
                  :label="`Cert`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12"  md="10">
            <v-row  justify="end">
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="itemdata.done"
                  :label="`Done`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12"  md="4">
                <v-checkbox
                  v-model="itemdata.nextdeadlineninety"
                  :label="`Done/Dupicate next deadline 60 days`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12"  md="5">
                <v-checkbox
                  v-model="itemdata.nextdeadlinesixty"
                  :label="`Done/Dupicate next deadline 120 days`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <br />
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn
          @click="$router.back()"
          depressed
          outlined
          width="100"
          color="red"
        >
          Delete
        </v-btn> -->
        <v-btn
          depressed
          class="mr-3 buttongold"
          @click="saveItem('paymentrequest')"
        >
          Payment Request
        </v-btn>
        <v-btn
          @click="saveItem('save')"
          width="100"
          class="mr-3 ml-3 buttonblue"
          color="#112D32"
        >
          Save
        </v-btn>
        <v-btn @click="$router.back()" depressed outlined width="100">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <br />
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogpreviewfilenotice" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkfileapreview"
          v-for="(item, index) in previewpopupfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreview"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading">
              loading content here...
            </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkattachfileapreview"
          v-for="(item, index) in previewpopupattachfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreviewattach"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading">
              loading content here...
            </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title
        >

        <v-img
          disabled
          :src="previewattachimage"
          class="grey lighten-2 mt-3 mb-5"
          aspect-ratio="1"
          contain
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachimage"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeletenoticefile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeletenoticefile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeleteattachfile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeleteattachfile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
    <SuccessDialogPushpaymentIM
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
      :querydata="querydata"
    />
  </v-container>
</template>

<script>
const moment = require('moment-timezone');
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import pdfvuer from "pdfvuer";

export default {
  name: "AppoinmrntPatentOperation",
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    await this.loaddatafile_no();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumentPTtype();

    // let map_data = await api.mapKeyWordPT(this.app_noshow, this.itemdata.refno);
    // this.itemdata.doctype = map_data.data.doctype_id;

    console.log("showapp_no:", this.app_noshow);
    console.log("showapp_no refno:", this.itemdata.refno);

    if (this.app_noshow !== "" && this.itemdata.refno !== "") {
      console.log("showapp_no refno:", "found data");
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.app_noshow,
        this.itemdata.refno
      );
      console.log("ocr_data:", JSON.stringify(ocr_data.data));

      if (ocr_data.data !== null) {
        console.log("showapp_no refno:", "found data ocr");
        let map_data = await api.mapKeyWordPT(
          this.app_noshow,
          this.itemdata.refno
        );
        this.itemdata.doctype = map_data.data.doctype_id;
      } else {
        console.log("showapp_no refno:", "not found data ocr");
      }

      // --------------- check data in map table ----------------
    }

    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    pdf: pdfvuer,
  },
  data() {
    return {
      querydata:{},
      dataappiontment:{},
      isShowPassword: false,
      fullPage: true,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      objecttype_list: [],
      menuReceive: false,
      menuStart: false,
      menuDeadline: false,
      sourcetypelist: ["Notice", "Notice-1", "Notice-2", "Mail"],
      category_ptlist: [
        "New Application",
        "Office Action",
        "Publication Fee",
        "Publication",
        "Substantive Examination",
        "Publication Fee & Registration Fee",
        "Publication Fee & Registration Fee & Annuity Fee",
        "Registration Fee",
        "Registration Fee & Annuity Fee",
        "Certificate",
        "Annuity Fee",
      ],
      typelist: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention/PCT", type_number: "4" },
      ],
      documenttype_ptlist: [],
      app_noshow: "",
      typeshow: 0,
      titleshow: "",
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      startdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      enddate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      internaldate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      itemdata: {
        objecttype: 0,
        doctype: 0,
        trademark_name: "",
        refno: "",
        categories: "",
        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        startdate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        enddate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        internaldate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        sourcetype: "",
        description: "",
        remark: "",
        report: false,
        paymentrequest: false,
        cert: false,
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        done: false,
      },
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      image_listattach: [],
      filenameattach: [],
      getpreview_listattach: [],
      preview_listattach2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      indexdeleteattachfile: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest:0,
    };
  },
  methods: {
    async previewMultiFile(event) {
      this.getpreview_listnotice = [];
      this.preview_listnotice = [];
      var getdataname = [];
      // this.image_listnotice = [];
      // this.filenamenotice = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listnotice.push(e.target.result);
            this.preview_listnotice.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listnotice.push(input.files[index]);
            getdataname.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.getpreview_listnotice);
      // await this.getPdf(this.getpreview_listnotice, "newfile");
      this.preview_listnotice2 = this.preview_listnotice;
      getdataname.forEach((x) => {
        this.filenamenotice.push(x.name);
      });
      this.checkfilenotice = true;
     
    },
    async previewnoticefilepdf(index) {
      // console.log(this.getpreview_listnotice)
      console.log(this.image_listnotice);
      var checkfile = this.image_listnotice[index];

      if(checkfile.type == `application/pdf`){
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${checkfile}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }else{
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result; // Base64 image data
          let image_newTab = window.open(""); // เปิดแท็บใหม่
          image_newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin: 50px 0 0 0;
                    height: 80%;
                    overflow: hidden;
                    background-color: black;
                    display: flex;
                    justify-content: center; /* จัดกลางในแนวนอน */
                    align-items: center; /* จัดกลางในแนวตั้ง */
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                  }
                </style>
              </head>
              <body>
                <img src="${checkfile}" title="Image Preview" />
              </body>
            </html>
          `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
      console.log(this.previewpopupfile);
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async previewMultiAttachFile() {
      // this.preview_listattach = [];
      // this.image_listattach = [];
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          console.log(input.files[index].type);
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.getpreview_listattach);
      // await this.getPdf(this.getpreview_listattach, "newfile");
      this.preview_listattach2 = this.preview_listattach;
      this.image_listattach.forEach((x) => {
        this.filenameattach.push(x.name);
      });
      this.checkfileattach = true;
      console.log(this.image_listattach);
    },
    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listattach[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
      console.log(this.previewpopupattachfile);
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    async loaddatafile_no() {
      if (this.$route.params.file_no) {
        this.itemdata.refno = this.$route.params.file_no;
        this.onSearchfile_no(this.itemdata.refno);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      //console.log(result.data);
      this.objecttype_list = result.data;
    },
    async loaddatadocumentPTtype() {
      const result = await api.getdocumenttype_ptcode();
      this.documenttype_ptlist = result.data;
    },
    async onSearchfile_no(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);
      console.log(result.data[0]);
      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.itemdata.objecttype = result.data[0].tm_type;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest = result.data[0].agent_contact_custid != 0 ? result.data[0].agent_contact_custid : result.data[0].owner_contact_custid != 0 ? result.data[0].owner_contact_custid : 0;
      } else {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async onSearchfile_nosave(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);
      //console.log(result.data[0]);
      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest = result.data[0].agent_contact_custid != 0 ? result.data[0].agent_contact_custid : result.data[0].owner_contact_custid != 0 ? result.data[0].owner_contact_custid : 0;
      } else {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    calDateFinalDeadline(){
      if (this.itemdata.doctype != 0 && this.itemdata.doctype) {
        const dataItem = this.documenttype_ptlist.find(
          (item) => item.documenttype_id === this.itemdata.doctype
        );

        const dateplus = dataItem.numberofenddate - 1;

        const [year, month, day] = this.receive_date.split("-").map(Number);
        const date = new Date(year, month - 1, day); // month - 1 เพราะ JS เริ่มที่ 0

        date.setDate(date.getDate() + dateplus); // บวกจำนวนวัน

        // แปลงกลับเป็น YYYY-MM-DD
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");

        this.itemdata.enddate = `${dd}/${mm}/${yyyy}`;
        this.itemdata.internaldate = `${dd}/${mm}/${yyyy}`;
      }
  
    },
    async saveItem(mode) {
      // console.log(this.itemdata);
      // return;
      this.onSearchfile_nosave(this.itemdata.refno);
      //console.log(this.itemdata);
      if (this.itemdata.refno == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File NO ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.trademark_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Client Name ",
          "text-h5 red--text text-center"
        );
        return;
      }
      const checkfile_noPT = await api.getfile_noPT(this.itemdata.refno);
      if (checkfile_noPT.data[0]) {
        // console.log(this.showaddItem);
        // this.itemdata.refno = this.itemdata.refno.trim();
        // this.itemdata.categories = this.itemdata.categories.trim();
        // this.itemdata.description = this.itemdata.description.trim();
        // this.itemdata.remark = this.itemdata.remark.trim();
        // this.itemdata.receive_date = this.changeformatDatetoinsert(
        //   this.itemdata.receive_date
        // );
        // this.itemdata.startdate = this.changeformatDatetoinsert(
        //   this.itemdata.startdate
        // );
        // this.itemdata.enddate = this.changeformatDatetoinsert(
        //   this.itemdata.enddate
        // );
        // this.itemdata.internaldate = this.changeformatDatetoinsert(
        //   this.itemdata.internaldate
        // );

        let formData = new FormData();
        if (this.image_listnotice.length > 0) {
          this.image_listnotice.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }
        if (this.image_listattach.length > 0) {
          this.image_listattach.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }
        if (this.image_listnotice.length > 0) {
          let getnamefilenameattach = "";
          this.filenamenotice.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `notice_file`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }
        if (this.image_listattach.length > 0) {
          let getnamefilenameattach = "";
          this.filenameattach.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `attachment_files`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }

        formData.append("objecttype", this.itemdata.objecttype);
        formData.append("doctype", this.itemdata.doctype);
        formData.append("cert", this.itemdata.cert);
        formData.append("done", this.itemdata.done);
        formData.append("nextdeadlineninety", this.itemdata.nextdeadlineninety);
        formData.append("nextdeadlinesixty", this.itemdata.nextdeadlinesixty);
        if (mode == "paymentrequest") {
          this.itemdata.paymentrequest = 1;  
        }
        formData.append("paymentrequest", this.itemdata.paymentrequest);

        formData.append("report", this.itemdata.report);
        formData.append("sourcetype", this.itemdata.sourcetype);
        formData.append("trademark_name", this.itemdata.trademark_name);
        formData.append(`refno`, this.itemdata.refno.trim());
        formData.append(`categories`, this.itemdata.categories.trim());
        formData.append(`description`, this.itemdata.description.trim());
        formData.append(`remark`, this.itemdata.remark);
        formData.append(
          `receive_date`,
          this.changeformatDatetoinsert(this.itemdata.receive_date)
        );
        formData.append(
          `startdate`,
          this.changeformatDatetoinsert(this.itemdata.startdate)
        );
        formData.append(
          `enddate`,
          this.changeformatDatetoinsert(this.itemdata.enddate)
        );
        formData.append(
          `internaldate`,
          this.changeformatDatetoinsert(this.itemdata.internaldate)
        );

        this.$showLoader();
        const resultAppointment = await api.AppointmentAddV2(formData);

        //console.log(resultAppointment.status);
        if (
          resultAppointment.status == 200 ||
          resultAppointment.status == 201
        ) {
          
          var dataAdd = {
              user_id: localStorage.getItem(server.USER_ID),
              log_in_out_id: localStorage.getItem(server.LOGIN_ID),
              action: "Create",
              table_name: "appointment",
              table_id: resultAppointment.data.appointment_id,
              date: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
          }

          await api.addTransectionLog(dataAdd)

          var dataEditLog = {
            last_update: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
          }
          await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID),dataEditLog)
          this.$hideLoader();
          
          if (mode == "paymentrequest") {
            let res_shearch_data = {
              objecttype_id: this.itemdata.objecttype,
              work_type: this.itemdata.doctype,
            }
            const res_data_table = await api.getIPPriceListS("PT",res_shearch_data)
            // console.log(res_data_table.data)
            this.dataappiontment = {};
            if(res_data_table.data.length > 0){
              this.dataappiontment = {
                description_inv: res_data_table.data[0].price_desc,
                price_inv: Number(res_data_table.data[0].thb)
              }
            }
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPushpaymentIM(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/new-free-invoice/0/invoice/D/${this.customer_id_forpatmentrequest}/IP`,
              this.dataappiontment
            );
            return;
          }else{
            this.$hideLoader();
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/appointment-patent-list"
            );
            return;
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setupAlertDialogPushpaymentIM(status, title, message, text_color, link,querydata) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  watch: {
    receive_date(val) {
      this.itemdata.receive_date = this.formatDate(this.receive_date);
    },
    startdate(val) {
      this.itemdata.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.itemdata.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.itemdata.internaldate = this.formatDate(this.internaldate);
    },
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  min-height: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}
.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.heightsize90formadvance {
  height: 90px;
}
.heightsizesearch {
  height: 45%;
}

h3 {
  font-size: 1.17em;
}
.widthbtnnoticefile {
  width: 100%;
}

.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}
</style>
